import {  IsNotEmpty, IsAlphanumeric, MaxLength, Matches, IsOptional, IsNumber } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';

export class GrnQtyRequest {
    @ApiProperty()
    @IsNotEmpty()
    purchaseOrderId: number;
    @ApiProperty()
    @IsNotEmpty()
    itemCategoryId: number;
    @ApiProperty()
    @IsNotEmpty()
    itemId: number;
    @ApiProperty()
    @IsNotEmpty()
    saleOrderId?: number;
}